import {connect} from 'react-redux'
import actions from 'redux-auto'

import TopLevelErrorModal from '.'

const mapStateToProps = state => ({
  showError: !!state.error.error,
  errorMessage: state.error.errorMessage,
  error: state.error.error,
})

const mapActionsToProps = () => ({
  onOkClicked: actions.error.reset,
})

export default connect(mapStateToProps, mapActionsToProps)(TopLevelErrorModal)
